import { mbSize, Media } from '@foxrenderfarm/common'
import styled from 'styled-components'

export const Wrapper = styled.div<{ $hideInMobile?: boolean; $tight?: boolean }>`
  display: flex;
  align-items: center;
  svg {
    margin: 0 ${({ $tight }) => ($tight ? '6px' : '16px')};
    flex-shrink: 0;
  }
  ${Media.lessThan(Media.small)} {
    display: ${({ $hideInMobile }) => ($hideInMobile ? 'none' : 'flex')};
  }
`

export const LinkItem = styled.div`
  font-size: 14px;
  font-weight: 400;
  color: #333333;
  white-space: nowrap;
  ${Media.lessThan(Media.small)} {
    font-size: ${mbSize(24)};
    &:last-child {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
`

export const PathText = styled.div`
  font-size: 14px;
  font-weight: 400;
  color: #999999;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`
